import React from 'react';
import { Box } from '@mui/material';

const CustomPaper = React.forwardRef(
  (
    {
      children,
      className,
      style,
      sx,
      elevation, // Will be ignored since we're not using elevation
      hidden,
      ...other
    },
    ref
  ) => {
    const baseStyles = {
      backgroundColor: 'background.paper',
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: '8px',
      padding: '16px',
      boxSizing: 'border-box',
      ...style,
    };

    const combinedSx = {
      ...baseStyles,
      ...sx,
    };

    return (
      <Box ref={ref} className={className} sx={combinedSx} hidden={hidden} {...other}>
        {children}
      </Box>
    );
  }
);

CustomPaper.displayName = 'CustomPaper';

export default CustomPaper;
